import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, type Persona } from '@/shared/stores/auth';

interface Props {
  persona: Persona;
  children: ReactNode;
}

export function ProtectedRoute({ persona, children }: Props) {
  const token = useAuthStore((s) => s.token);
  const currentPersona = useAuthStore((s) => s.persona);

  if (!token || !currentPersona) {
    return <Navigate to="/login" replace />;
  }

  if (currentPersona !== persona) {
    return <Navigate to={`/${currentPersona}`} replace />;
  }

  return <>{children}</>;
}
